export const ISTA_QUERY_PARAM = {
  t: 'ista',
} as const;
